var _a;
import { __decorate, __metadata, __param } from "tslib";
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { FieldEditorService } from '@/presentation/components/field-editor/field-editor-service.interface';
let LayerFieldDataServiceImp = class LayerFieldDataServiceImp {
    constructor(_fieldEditorService) {
        this._fieldEditorService = _fieldEditorService;
    }
    getLayerFieldData() {
        const treeData = this._fieldEditorService.structor;
        return [...treeData || []];
    }
    setLayerFieldData(data) {
        this._fieldEditorService.structor = data;
        if (this._fieldEditorService.field) {
            this._fieldEditorService.field.field_layer_value = data;
        }
    }
};
LayerFieldDataServiceImp = __decorate([
    injectable(),
    __param(0, inject(FieldEditorService)),
    __metadata("design:paramtypes", [typeof (_a = typeof FieldEditorService !== "undefined" && FieldEditorService) === "function" ? _a : Object])
], LayerFieldDataServiceImp);
export { LayerFieldDataServiceImp };
